import { Component } from '@angular/core'
import { CellComponent } from '@spartacus/organization/administration/components'
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront'

@Component({
    selector: 'eb-order-history-documents-table-document-category',
    templateUrl: './eb-order-history-documents-table-document-category.component.html',
    standalone: false
})
export class EbOrderHistoryDocumentsTableDocumentCategoryComponent extends CellComponent {
  constructor(outlet: OutletContextData<TableDataOutletContext>) {
    super(outlet)
  }

  resolveDocumentCategory(category) {
    const categoryMapping = {
      SDOINVOICE: 'invoice',
      SDOORDER: 'order',
      SDOQUOTAT: 'quotation',
      SDODELNOTE: 'deliveryConfirmation'
    }
    return categoryMapping[category]
  }
}
